import ProductAddons from '@components/ProductAddons';
import {useProductDisplay} from '@contexts/index';

const ProductDisplayAccessories = () => {
  const {state} = useProductDisplay();
  const {accessories} = state;
  return (
    <div>
      {Object.keys(accessories).map(product_group_id => {
        return (
          <ProductAddons
            key={product_group_id}
            product_group_id={product_group_id}
          />
        );
      })}
    </div>
  );
};

export default ProductDisplayAccessories;
